<mat-form-field class="narrow-infix w-full" floatLabel="always">
  <mat-label>Country</mat-label>
  <input placeholder="Country" i18n-placeholder class="country-code" type="text" matInput #formInput [matAutocomplete]="autocomplete" [formControl]="control" (input)="onInput()" (blur)="onBlur()">
  <mat-error>{{ control.errors?.violations[0]?.message }}</mat-error>
  <mat-autocomplete #autocomplete (optionSelected)="onOptionSelected($event)">
    @for (country of filteredCountries$ | async; track country) {
      <mat-option [value]="country">
        {{ country | countryName }}
      </mat-option>
    }
  </mat-autocomplete>
  <span matTextSuffix class="country-name opacity-50">{{ control.value | countryName }}</span>
</mat-form-field>